const AutoFilled: React.FC = () => {
  return <div>(自動入力)</div>;
};

export default AutoFilled;
